import { Platform, Clipboard } from 'react-native';

/** Copy plain text; works on web and native. */
export async function copyTextToClipboard(text) {
  const val = String(text || '');
  if (!val) return false;
  if (Platform.OS === 'web') {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(val);
      return true;
    }
    if (typeof document !== 'undefined') {
      const textArea = document.createElement('textarea');
      textArea.value = val;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    }
    return false;
  }
  Clipboard.setString(val);
  return true;
}
